import React, { useEffect, useCallback } from 'react';
import publisherlogo from "../assets/publisher-logo.png";
import gamelogo from "../assets/game-logo.png";
import { useLanguage } from '../contexts/LanguageContext';

export default function QuestionSet({ setQuestionSet, sound, questionSets }) {
  const { language } = useLanguage();
  const handleSelect = useCallback((setId) => {
    if (sound) {
      sound.fade(sound.volume(), 0, 1500);
      setTimeout(() => {
        setQuestionSet(setId);
      }, 1500);
    } else {
      setQuestionSet(setId);
    }
  }, [sound, setQuestionSet]);

  // Automatically select if only one question set is available
  useEffect(() => {
    if (questionSets && questionSets.length === 1) {
      handleSelect(questionSets[0].id);
    }
  }, [questionSets, handleSelect]);

  return (
    <div className="start">
      <div className="logo-bar">
          <img src={publisherlogo} alt={language.altText.publisherLogo} className="logo-left" />
          <img src={gamelogo} alt={language.altText.gameLogo} className="logo-right" />
      </div>
      <div className="content" >                
          <div className="dialog">
            <h2>{language.questionSet.title}</h2>
            {questionSets.map((set) => (
              <button 
                key={set.id} 
                className="main-btn" 
                onClick={() => handleSelect(set.id)}
              >
                {set.data.name}
              </button>
            ))}
          </div>
      </div>
    </div>
  );
}
